(function () {

  /* ── FAQ accordion ── */
  document.querySelectorAll('.it-faq-item').forEach(function (item) {
    var q = item.querySelector('.it-faq-q');
    var a = item.querySelector('.it-faq-a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = item.classList.contains('it-open');
      document.querySelectorAll('.it-faq-q[aria-expanded="true"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('.it-faq-item.it-open').forEach(function (o) {
        o.classList.remove('it-open');
        var oa = o.querySelector('.it-faq-a');
        if (oa) oa.style.maxHeight = null;
      });
      if (!open) {
        item.classList.add('it-open');
        q.setAttribute('aria-expanded', 'true');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  /* Keep an open answer the right height when the text reflows. */
  window.addEventListener('resize', function () {
    var open = document.querySelector('.it-faq-item.it-open .it-faq-a');
    if (open) open.style.maxHeight = open.scrollHeight + 'px';
  });

  /* ── The collection carousel ── */
  document.querySelectorAll('.it-car').forEach(function (car) {
    var track = car.querySelector('.it-track');
    var prev  = car.querySelector('.it-car-prev');
    var next  = car.querySelector('.it-car-next');
    if (!track || !prev || !next) return;
    var sync = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      var fits = track.scrollWidth <= track.clientWidth + 2;
      prev.style.display = next.style.display = fits ? 'none' : '';
    };
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior:'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left:  track.clientWidth, behavior:'smooth' }); });
    track.addEventListener('scroll', sync, { passive:true });
    window.addEventListener('resize', sync);
    sync(); setTimeout(sync, 400);
  });

  /* ── Scroll reveal ── */
  var showAll = function () {
    document.querySelectorAll('.it-reveal').forEach(function (el) { el.classList.add('it-vis'); });
  };

  if ('IntersectionObserver' in window) {
    var fired = false;
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { fired = true; e.target.classList.add('it-vis'); ro.unobserve(e.target); }
      });
    }, { threshold:0.1, rootMargin:'0px 0px -36px 0px' });
    document.querySelectorAll('.it-reveal').forEach(function (el) { ro.observe(el); });

    /* Safety net. The reveals start at opacity 0, so if the observer
       never reports anything the whole page would sit invisible. That
       happens in a frame with no height — some theme previews render
       one — and wherever the API is stubbed out. In a normal browser
       the elements already on screen intersect straight away, so
       `fired` is true within a frame or two and this does nothing. */
    setTimeout(function () {
      if (fired && window.innerHeight) return;
      showAll();
    }, 2600);
  } else {
    showAll();
  }

  /* ── Hero reveals fire immediately ── */
  setTimeout(function () {
    document.querySelectorAll('.it-hero .it-reveal').forEach(function (el) { el.classList.add('it-vis'); });
  }, 180);

  /* ── Smooth scroll ── */
  document.querySelectorAll('a[href^="#it-"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior:'smooth' }); }
    });
  });

})();